// extracted by mini-css-extract-plugin
export default {"editButton":"addPayroll_editButton__HbozS","TableBody":"addPayroll_TableBody__bimjn","deleteButton":"addPayroll_deleteButton__LaBe3"};